import {HttpStatusCodeEnum} from 'src/app/enums/http-status-code.enum';
import {ValidationError} from 'src/app/models/validation-error.model';

export class HttpError {
  constructor(public statusCode: HttpStatusCodeEnum, public message: string, public validationErrors?: ValidationError[]) {
    this.validationErrors = validationErrors || [];
  }

  public containsCode(code: string): boolean {
    return this.validationErrors != null && this.validationErrors.find(e => e.code === code) != null;
  }

  public getMessage(): string {
    if (this.validationErrors && this.validationErrors.length > 0) {
      return this.validationErrors[0].message;
    }
    return this.message;
  }
}
